import Sticky from 'sticky-js';
new Sticky('.data-sticky-element');
